import {httpClient} from '@/services/axios';
import {defaultResponse} from "@/helpers/functionsHelpers";

const END_POINT_METADATA = '/api/v1/metadata/';

class MetadataService {
  fetchDefault() {
    return httpClient.get(END_POINT_METADATA.concat('list/defaultsPrice')).then((dataResponse) => {
      return defaultResponse(dataResponse);
    });
  }

  listManufactures() {
    return httpClient.get(END_POINT_METADATA.concat('list/manufactures')).then((dataResponse) => {
      return defaultResponse(dataResponse);
    });
  }

  saveManufactures(manufactures) {
    return httpClient.post(END_POINT_METADATA.concat('save/manufactures'), manufactures).then((dataResponse) => {
      return defaultResponse(dataResponse);
    });
  }
}

export default new MetadataService();
